/**
 * Reload the page when the browser restores it from the back/forward cache.
 *
 * A page restored that way does not run any script again, so it can show a chat after the session has ended.
 * A reload makes the app ask `/api/auth/me` again and show the sign-in page when the session is gone.
 * Returns a function that removes the listener.
 */
export function reloadWhenRestoredFromCache(): () => void {
  const onPageShow = (event: PageTransitionEvent) => {
    if (event.persisted) {
      window.location.reload();
    }
  };
  window.addEventListener('pageshow', onPageShow);
  return () => window.removeEventListener('pageshow', onPageShow);
}
